import { render, staticRenderFns } from "./WalletHistory.vue?vue&type=template&id=b85b6160&scoped=true&"
import script from "./WalletHistory.vue?vue&type=script&lang=js&"
export * from "./WalletHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85b6160",
  null
  
)

export default component.exports